// paex-sticky-delivery.js — Halloween clock - PE (2026-10-09), §11: the
// delivery line on the sticky add-to-cart bar (phones AND desktop since 2026-10-20) of the main product
// section. Loaded by snippets/paex-delivery-method.liquid (after the block
// element) only while the clock is active and settings.paex_clock_sticky_line
// is 'date' or 'countdown'. Native files untouched: the line is a <span>
// appended to the SIZE row of #Product-Mini-Checkout-{section}'s
// .product-content (snippets/buy-buttons.liquid: "One Size · Order within
// 14 h 19 min"), so the bar keeps its original height (Sasha 2026-10-09:
// "same size of sticky as before, the get-it-by next to the size"); a
// default-variant product gets a small row under the price instead.
// global.js swaps .product-content on variant change, so ensureLine()
// re-inserts the line after every swap (render runs on variantChange).
// Minutes only (paexClock.bindCountdown { minutes }) — a width that moves
// once an hour at most beside the size text; nowrap + ellipsis guard.
//
// Honest by construction — every value comes from the PDP block (paex-
// delivery-method.js: sellability, the tile's own live-upgraded date, the
// product's clock verdict, the store snapshot) and the shared clock:
//  - date      → "Order today, get it {date}" (sticky_date), the tile's date;
//  - countdown → "Order within {time}" (sticky_within) bound to the shared
//                ticker while the warehouse takes today's orders, else date;
//  - late      → "In store today at {store}" (sticky_late) only when the
//                shopper's store has ≥ 3 on the snapshot and opens today,
//                else "Too late to ship? Visit our stores" (generic), amber.
// Not sellable online → no text (row reserved). Unknown destination / remote /
// US (verdict 'unknown') → the tile's own estimate date, like the tile (Sasha
// 2026-10-20: "it should always display… based on the location of the user"). One countdown per page: while the
// occasion pill ticks (paex-occasion[data-paex-ticking]) the line shows the
// date wording.
//
// BOPIS (2026-10-22, plan 6c, seams §1 step 2): a MODE branch sits before the
// onlineAvailable() guard. While the block's "Buy online" selector is on, the
// line reads the block's own fulfilSticky() contract (lane P5, design S.1–S.7:
// "Arrives {date} · {place}" / "Pickup · ready in 2 h" / "Same-day delivery ·
// before {cutoff}", paex.fulfil.sticky_*), and when the selected service still
// needs a postal code the bar's Add opens the block's postal editor instead of
// adding. Re-rendered on paex:fulfil-change / paex:fulfil-select. No selector
// (out of region, design S.8) = the pre-BOPIS path byte for byte. Round 2
// (lane A2, design findings 2 / 48): when the selected service cannot fulfil
// the variant the line carries the reason (tone 'warn') and the bar's Add is
// disabled like the main CTA (host.syncStickyCta).

(function () {
  if (window.paexStickyDelivery) return;
  window.paexStickyDelivery = true;

  var STORE_MIN = 3; // snapshot units before a store is named (honesty rule)
  var line = null;
  var host = null;
  var clock = null;
  var lastKey = '';
  // Sasha 2026-10-20: the line is not a clock feature — the script tag carries the
  // mode and the date wording so the line works with the clock off (date mode);
  // a running clock adds the countdown / "too late" wording.
  var tag = document.currentScript;
  var own = { mode: (tag && tag.getAttribute('data-paex-sticky-mode')) || 'date', date: (tag && tag.getAttribute('data-paex-sticky-date')) || 'Order today, get it {date}' };
  function clockOn() { return Boolean(clock && clock.state && clock.state.phase !== 'off'); }
  function T(key) { return clock && typeof clock.t === 'function' ? clock.t(key) : (key === 'sticky_date' ? own.date : ''); }

  // the main product section's block — never a quick-add / quick-view copy
  function findHost() {
    var list = document.querySelectorAll('.section-main-product paex-delivery-method');
    for (var i = 0; i < list.length; i += 1) {
      var el = list[i];
      if (el.dataset.originalSection) continue;
      if (el.closest('quick-add-modal, .quick-add-modal, modal-dialog, product-modal')) continue;
      if (typeof el.estimate === 'function' && el.data) return el;
    }
    return null;
  }

  function ensureLine() {
    if (line && line.isConnected) return line;
    var bar = host && document.getElementById('Product-Mini-Checkout-' + host.dataset.section);
    if (!bar || !bar.closest('.section-main-product')) return null;
    line = bar.querySelector('[data-paex-mini-dl]');
    if (line) return line;
    var content = bar.querySelector('.product-content');
    if (!content) return null;
    // approved design (Sasha 2026-10-09): line 1 = "64.99 $ · M (7-8)" (the
    // price and the size on ONE line, CSS .paex-mini-dl-on), line 2 = the
    // delivery sentence in green — the bar keeps its two-line height
    content.classList.add('paex-mini-dl-on');
    var row = document.createElement('div');
    row.className = 'paex-mini-dl-row';
    line = document.createElement('span');
    line.className = 'paex-mini-dl';
    line.setAttribute('data-paex-mini-dl', '');
    line.setAttribute('data-paex-empty', '');
    row.appendChild(line);
    content.appendChild(row);
    return line;
  }

  function mode() {
    var flags = clock && clock.config && clock.config.flags;
    if (flags && (flags.sticky === 'date' || flags.sticky === 'countdown')) return flags.sticky;
    return own.mode === 'countdown' || own.mode === 'date' ? own.mode : 'off';
  }

  // nothing honest to show: empty the line but keep its row (the bar keeps
  // one height); collapse = the clock / sticky flag is off for good
  function hide(collapse) {
    if (!line) return;
    if (clock && typeof clock.unbind === 'function') clock.unbind(line.querySelector('.paex-mini-dl__time'));
    lastKey = '';
    line.textContent = '';
    line.removeAttribute('data-tone');
    line.setAttribute('data-paex-empty', '');
    line.hidden = Boolean(collapse);
  }

  // "In store today at {store}" only on data: the block's chosen store, ≥ 3
  // units on the store snapshot for this variant, open now or later today
  function storeName() {
    var id = host.storeId;
    var store = id && host.data.stores && host.data.stores[id];
    if (!store || !host.variantId) return '';
    if (host.qtyFor(host.variantId, id) < STORE_MIN) return '';
    var info = typeof paexStoreHoursInfo === 'function' ? paexStoreHoursInfo(store) : null;
    var openToday = info && (info.state === 'open' || info.state === 'closes_soon' || info.nextOpenIsToday);
    if (!openToday) return '';
    return (host.displayNames && host.displayNames[id]) || '';
  }

  function fill(template, values, tone, key) {
    if (key === lastKey && line.textContent) return;
    lastKey = key;
    paexFillTemplate(line, template, values, { date: 'paex-mini-dl__date', time: 'paex-mini-dl__time', place: 'paex-mini-dl__place' });
    if (tone) line.setAttribute('data-tone', tone);
    else line.removeAttribute('data-tone');
    line.removeAttribute('data-paex-empty');
    line.hidden = false;
  }

  // BOPIS: while the selected service still needs a postal code the bar's
  // add button carries data-paex-postal — its click opens the block's editor
  // (see connect()) instead of adding. Design S.6 (round 3, lane A4): the
  // button KEEPS its own short label ("Add"), muted by CSS; a `button` word
  // in the contract (none today) would replace the label. The button
  // survives the .product-content swap (global.js replaces only the image +
  // content).
  function modeButton(state) {
    var bar = host && document.getElementById('Product-Mini-Checkout-' + host.dataset.section);
    var button = bar && bar.querySelector('.mini-check-add, button[type="submit"][name="add"]');
    if (!button) return;
    var label = button.querySelector('.button-text') || button;
    var on = Boolean(state && state.postal);
    if (on) {
      if (!button.hasAttribute('data-paex-postal')) {
        button.setAttribute('data-paex-postal-label', label.textContent);
        button.setAttribute('data-paex-postal', '');
      }
      if (state.button && label.textContent !== state.button) label.textContent = state.button;
    } else if (button.hasAttribute('data-paex-postal')) {
      label.textContent = button.getAttribute('data-paex-postal-label') || label.textContent;
      button.removeAttribute('data-paex-postal');
      button.removeAttribute('data-paex-postal-label');
    }
  }

  function render() {
    // the main section re-rendered (theme editor, section reload): follow
    // the new block instead of a detached one
    if (!host || !host.isConnected) host = findHost();
    if (!host || !ensureLine()) return;
    if (mode() === 'off') {
      hide(true);
      return;
    }
    // BOPIS mode branch (before the online guard: a DC-out item still has a
    // pickup line) — the block owns every word (texts.fulfil.*)
    var fulfil = typeof host.fulfilSticky === 'function' ? host.fulfilSticky() : null;
    modeButton(fulfil);
    // round 2 (design findings 2 / 48): the bar's Add mirrors the block's service-disabled CTA — the
    // block owns the rule (syncStickyCta runs in applyButton too; this call covers the bar's own repaints)
    if (typeof host.syncStickyCta === 'function') host.syncStickyCta();
    if (fulfil) {
      if (!fulfil.text) {
        hide(false);
        line.setAttribute('data-service', fulfil.service);
        return;
      }
      // an unavailable service reads its reason in the amber 'warn' tone (the pre-BOPIS "late" wording's);
      // lane P5 (design S.1): a line with `values` is a template — "Arrives {date} · {place}", the date in the
      // bar's own date class
      fill(fulfil.text, fulfil.values || {}, fulfil.tone || '', 'fulfil|' + fulfil.key);
      line.setAttribute('data-service', fulfil.service);
      line.toggleAttribute('data-unavailable', Boolean(fulfil.unavailable));
      return;
    }
    line.removeAttribute('data-unavailable');
    line.removeAttribute('data-service');
    if (!host.onlineAvailable()) {
      hide(false);
      return;
    }
    // clock off (or outside its window): plain date wording from the tile's estimate
    var state = clockOn() ? clock.state : null;
    var verdict = state ? host.clockVerdict : null;
    if (verdict === 'off') verdict = null;
    // Sasha 2026-10-20: the line always shows the date for the shopper's
    // location — an 'unknown' verdict (no usable location, remote zone, US) or
    // a verdict not settled yet falls through to the same estimate the tile
    // shows ("Arrives {date}": the '*' row answers when no destination is known)
    if (verdict === 'late') {
      var store = storeName();
      if (store) fill(T('sticky_late'), { store: store }, 'warn', 'late|' + store);
      else fill(T('sticky_late_generic'), {}, 'warn', 'late|');
      return;
    }
    var estimate = host.estimate();
    if (!estimate) {
      hide(false);
      return;
    }
    var date = paexEddFormatDate(estimate.arrival);
    var ticking = document.querySelector('paex-occasion[data-paex-ticking]');
    // same rule as the tile (Sasha 2026-10-09): the timer counts to the next
    // daily cutoff, every day; the date comes from the engine
    if (state && mode() === 'countdown' && !ticking && state.trusted !== false &&
        typeof clock.msToDailyCutoff === 'function' && clock.msToDailyCutoff() >= 1000) {
      var key = 'cd|' + date;
      var bound = line.querySelector('.paex-mini-dl__time.paex-clock-cd');
      if (key === lastKey && bound) return;
      lastKey = '';
      fill(T('sticky_within'), { time: '' }, '', key);
      var time = line.querySelector('.paex-mini-dl__time');
      var sr = document.createElement('span');
      sr.className = 'visually-hidden';
      if (time) time.after(sr);
      if (time && clock.bindCountdown(time, { srEl: sr, daily: true, minutes: true, onExpire: render })) return;
      lastKey = ''; // no honest countdown: date wording below
    }
    fill(T('sticky_date'), { date: date }, '', 'date|' + date);
  }

  var connected = false;
  function start() {
    clock = window.paexClock || null;
    if (mode() === 'off') return;
    if (connected) { setTimeout(render, 0); return; } // the clock arrived after the line: repaint
    var connect = function () {
      host = findHost();
      if (!host) return;
      connected = true;
      render();
      ['paex:clock-change', 'paex:clock-cutoff', 'paex:pdp-clock', 'paex:occ-ticking', 'paex:store-change', 'paex:dest-change', 'paex:geo-ready', 'paex:fulfil-change', 'paex:fulfil-select'].forEach(function (type) {
        // after the block's own handlers (same event) have re-rendered
        document.addEventListener(type, function () { setTimeout(render, 0); });
      });
      // BOPIS: while the bar's button reads "Postal code" its tap opens the
      // block's editor instead of the add path (capture: ahead of product-form)
      var bar = document.getElementById('Product-Mini-Checkout-' + host.dataset.section);
      if (bar && !bar.hasAttribute('data-paex-fulfil-bound')) {
        bar.setAttribute('data-paex-fulfil-bound', '');
        bar.addEventListener('click', function (event) {
          var button = event.target.closest('[data-paex-postal]');
          if (!button || !bar.contains(button)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (host && typeof host.openLocalPostal === 'function') host.openLocalPostal();
        }, true);
      }
      if (typeof webvista !== 'undefined' && webvista.subscribe && typeof PUB_SUB_EVENTS !== 'undefined') {
        webvista.subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(render, 0); });
      }
      // the live-date upgrade lands on the block without an event; the
      // clock's minute heartbeat picks it up (text only, no height change)
      document.addEventListener('paex:clock-minute', render);
      // without the clock there is no heartbeat: follow the tile's own
      // "Arrives {date}" line — when it changes, the sticky line repaints
      // (Sasha 2026-10-20: dev test showed the sticky date lagging the tile)
      var arrives = host.querySelector('[data-arrives]');
      if (arrives && window.MutationObserver) {
        new MutationObserver(function () { setTimeout(render, 0); }).observe(arrives, { childList: true, characterData: true, subtree: true });
      }
    };
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('paex-delivery-method').then(connect).catch(function () {});
    } else {
      connect();
    }
  }

  // start with or without the clock; a clock that boots later repaints the line
  start();
  document.addEventListener('paex:clock-ready', start, { once: true });
})();
